export enum GTMUserType {
    Strong = 'strong',
    Weak = 'weak',
}

export type GTMUserDataSource = {
    id?: string;
    isStrong?: boolean;
    email?: string;
    contactNumber?: string;
};

export type GTMUserData = {
    user_id: string;
    user_type: GTMUserType | '';
    email: string;
    phone: string;
};

export type GTMUserDataOptions = {
    guestUserId?: string;
    guestUserType?: GTMUserType | '';
};

export const mapGTMUserData = (
    userData?: GTMUserDataSource | null,
    { guestUserId = 'Guest', guestUserType = '' }: GTMUserDataOptions = {},
): GTMUserData => {
    const authenticatedUserType = userData && (userData.isStrong ? GTMUserType.Strong : GTMUserType.Weak);

    return {
        user_id: userData?.id || guestUserId,
        user_type: authenticatedUserType || guestUserType,
        email: userData?.email || '',
        phone: userData?.contactNumber || '',
    };
};
